import styled from 'styled-components';
import { Rating, Verbatim as VerbatimBase } from '@hamrolt/components';
import { PreloadedImage } from './PreloadedImage';
import { useQuery } from '@apollo/client';
import { GET_VERBATIM } from '../graphql/queries';

interface Props {
    componentId: string;
    locale: string;
    className?: string;
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Image = styled(PreloadedImage)`
	position: relative;
	width: 104px;
	height: 104px;
	margin-bottom: 8px;
	border: 4px solid #fff;
	border-radius: 50%;
`;

export const Verbatim = ({ componentId, locale, className }: Props) => {
    const { data, loading } = useQuery(GET_VERBATIM, { variables: { id: componentId, locale } });

    return loading
        ? <div>loading</div>
        : <Container className={className} data-testid="verbatim">
            {/* {data.verbatim.image && <Image id={data.verbatim.image} />} */}
            <Rating value={5} />
            <VerbatimBase author={data.verbatim.author} content={data.verbatim.body} />
        </Container>
};